import { Close, Save } from "@mui/icons-material"
import { LoadingButton } from "@mui/lab";
import { Autocomplete, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Grid, InputAdornment, TextField } from "@mui/material";
import ArgonBox from "components/ArgonBox";
import ArgonButton from "components/ArgonButton"
import ArgonInput from "components/ArgonInput";
import ArgonTypography from "components/ArgonTypography";
import { getDataWithResponse } from "global/getFunc";
import { postSubmit } from "global/postFunc";
import { useEffect, useState } from "react";
import PropTypes from "prop-types";


const TambahSubKegiatan = ({
    parentData,
    open,
    handleCloseDialog,
    decryptedUser,
    tahunAnggaran,
    updating,
    setUpdating,
    addReq
}) => {
    const [listSubKegiatan, setListSubKegiatan] = useState([])
    const [loading, setLoading] = useState(false)
    const [saving, setSaving] = useState(false)

    const [anggaran, setAnggaran] = useState('')
    const [subKegiatan, setSubKegiatan] = useState('')
    const [targetKinerja, setTargetKinerja] = useState('')

    useEffect(() => {
        if (open) {
            console.log(parentData);
            reqListSubKegiatan();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [open])
    
    useEffect(() => {
        console.log(subKegiatan);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [subKegiatan])

    const reqListSubKegiatan = () => {
        addReq()
        setListSubKegiatan([])
        setLoading(true)
        getDataWithResponse(
            `/admin-opd/get-dt-sub-kegiatan-by-kegiatan/${parentData.kode}`,
            // '/admin-opd/get-sub-kegiatan-by-kegiatan/' + parentData.id_kegiatan,
            decryptedUser,
            (res) => {
                setLoading(false)
                setListSubKegiatan(res)
                console.log(res);
            },
            (res) => {
                setLoading(false)
                handleCloseDialog()
            }
        );
    }

    const submit = (e) => {
        addReq()
        e.preventDefault();
        setSaving(true)
        postSubmit(
            '/admin-opd/tr-perencanaan/tambah',
            {
                id: `${tahunAnggaran.ta}-${parentData.kd_pd}-${subKegiatan.kode}`,
                ta: parentData.ta,
                kd_pd: parentData.kd_pd,
                kode: subKegiatan.kode,
                program: `${subKegiatan.urusan}.${subKegiatan.bidang_urusan}.${subKegiatan.program}`,
                kegiatan: parentData.kode,
                sub_kegiatan: subKegiatan.kode,
                uraian: subKegiatan.uraian,
                kinerja: subKegiatan.kinerja,
                indikator: subKegiatan.indikator,
                satuan: subKegiatan.satuan,
                anggaran: anggaran.replace(/,(?=\d{3})/g, ''),
                target: targetKinerja,
                ket: 'SUB KEGIATAN'
            },
            decryptedUser,
            (res) => {
                setSaving(false)
                handleCloseDialog()
                setSubKegiatan('')
                setAnggaran('')
                setUpdating(!updating)
            },
            (res) => {
                setSaving(false)
                handleCloseDialog()
            }
        )
        // console.log('submit');
    }

    const addCommas = num => num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    const removeNonNumeric = num => num.toString().replace(/[^0-9]/g, "");
    const handleAnggaranChange = (event) => {
        setAnggaran(addCommas(removeNonNumeric(event.target.value)))
    }

    return (
        <Dialog
            open={open}
            maxWidth="md"
            fullWidth
            // fullScreen
            scroll='paper'
            p={3}
            component='form'
            onSubmit={submit}
        >
            <DialogTitle>
                <ArgonTypography variant='body2' fontWeight="bold">Input Sub Kegiatan</ArgonTypography>
            </DialogTitle>
            <DialogContent p={3}>
                <ArgonBox mb={1}>
                    {/* <ArgonBox mb={1} ml={0.5}> */}
                    <ArgonTypography component="label" variant="caption" fontWeight="bold">
                        Kegiatan : {parentData.kode} {parentData.uraian}
                    </ArgonTypography>
                    {/* </ArgonBox> */}
                </ArgonBox>
                <ArgonBox mb={1}>
                    <ArgonBox mb={1} ml={0.5}>
                        <ArgonTypography component="label" variant="caption" fontWeight="bold">
                            Prioritas Pembangunan Nasional
                        </ArgonTypography>
                    </ArgonBox>
                    <Autocomplete
                        // disablePortal
                        id="combo-box-demo"
                        options={listSubKegiatan}
                        fullWidth
                        // required
                        disabled
                        getOptionLabel={(option) => option.kode + ' ' + option.uraian}
                        onChange={(event, newValue) => {
                            newValue !== null && setSubKegiatan(newValue)
                        }}
                        onInputChange={(event, newInputValue) => {
                            newInputValue === "" && setSubKegiatan('')
                        }}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                InputProps={{
                                    ...params.InputProps,
                                    endAdornment: (
                                        <>
                                            {loading ? <CircularProgress color="inherit" size={20} /> : null}
                                            {params.InputProps.endAdornment}
                                        </>
                                    ),
                                }}
                            />
                        )}
                    />
                </ArgonBox>
                <ArgonBox mb={1}>
                    <ArgonBox mb={1} ml={0.5}>
                        <ArgonTypography component="label" variant="caption" fontWeight="bold">
                            Prioritas Pembangunan Provinsi
                        </ArgonTypography>
                    </ArgonBox>
                    <Autocomplete
                        // disablePortal
                        id="combo-box-demo"
                        options={listSubKegiatan}
                        fullWidth
                        // required
                        disabled
                        getOptionLabel={(option) => option.kode + ' ' + option.uraian}
                        onChange={(event, newValue) => {
                            newValue !== null && setSubKegiatan(newValue)
                        }}
                        onInputChange={(event, newInputValue) => {
                            newInputValue === "" && setSubKegiatan('')
                        }}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                InputProps={{
                                    ...params.InputProps,
                                    endAdornment: (
                                        <>
                                            {loading ? <CircularProgress color="inherit" size={20} /> : null}
                                            {params.InputProps.endAdornment}
                                        </>
                                    ),
                                }}
                            />
                        )}
                    />
                </ArgonBox>
                <ArgonBox mb={1}>
                    <ArgonBox mb={1} ml={0.5}>
                        <ArgonTypography component="label" variant="caption" fontWeight="bold">
                            Prioritas Pembangunan Kabupaten / Kota
                        </ArgonTypography>
                    </ArgonBox>
                    <Autocomplete
                        // disablePortal
                        id="combo-box-demo"
                        options={listSubKegiatan}
                        fullWidth
                        // required
                        disabled
                        getOptionLabel={(option) => option.kode + ' ' + option.uraian}
                        onChange={(event, newValue) => {
                            newValue !== null && setSubKegiatan(newValue)
                        }}
                        onInputChange={(event, newInputValue) => {
                            newInputValue === "" && setSubKegiatan('')
                        }}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                InputProps={{
                                    ...params.InputProps,
                                    endAdornment: (
                                        <>
                                            {loading ? <CircularProgress color="inherit" size={20} /> : null}
                                            {params.InputProps.endAdornment}
                                        </>
                                    ),
                                }}
                            />
                        )}
                    />
                </ArgonBox>
                <ArgonBox mb={1}>
                    <ArgonBox mb={1} ml={0.5}>
                        <ArgonTypography component="label" variant="caption" fontWeight="bold">
                            Sub Kegiatan
                        </ArgonTypography>
                    </ArgonBox>
                    <Autocomplete
                        // disablePortal
                        id="combo-box-demo"
                        options={listSubKegiatan}
                        fullWidth
                        required
                        getOptionLabel={(option) => option.kode + ' ' + option.uraian}
                        onChange={(event, newValue) => {
                            newValue !== null && setSubKegiatan(newValue)
                        }}
                        onInputChange={(event, newInputValue) => {
                            newInputValue === "" && setSubKegiatan('')
                        }}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                InputProps={{
                                    ...params.InputProps,
                                    endAdornment: (
                                        <>
                                            {loading ? <CircularProgress color="inherit" size={20} /> : null}
                                            {params.InputProps.endAdornment}
                                        </>
                                    ),
                                }}
                            />
                        )}
                    />
                </ArgonBox>
                {
                    subKegiatan?.kode &&
                    <ArgonBox mb={1}>
                        <ArgonBox mb={1} ml={0.5}>
                            <ArgonTypography component="label" variant="caption" fontWeight="bold">
                                Target Kinerja ({subKegiatan.indikator})
                            </ArgonTypography>
                        </ArgonBox>
                        <ArgonInput
                            type="text"
                            required
                            size="medium"
                            value={targetKinerja}
                            onChange={(e) => setTargetKinerja(e.target.value)}
                            autoComplete='off'
                            endAdornment={
                                <InputAdornment position="end">
                                    <ArgonTypography component="label" variant="caption" >
                                        {subKegiatan.satuan}
                                    </ArgonTypography>
                                </InputAdornment>
                            }
                        />
                    </ArgonBox>
                }
                <ArgonBox mb={1}>
                    <ArgonBox mb={1} ml={0.5}>
                        <ArgonTypography component="label" variant="caption" fontWeight="bold">
                            Anggaran
                        </ArgonTypography>
                    </ArgonBox>
                    <ArgonInput
                        type="text"
                        required
                        size="medium"
                        value={anggaran}
                        onChange={handleAnggaranChange}
                        autoComplete='off'
                        startAdornment={
                            <InputAdornment position="start">
                                <ArgonTypography component="label" variant="caption" >
                                    Rp
                                </ArgonTypography>
                            </InputAdornment>
                        }
                    />
                </ArgonBox>
            </DialogContent>
            <DialogActions>
                <Grid container spacing={2} justifyContent='flex-end' px={2} mb={2}>
                    <Grid item>
                        <ArgonButton
                            color='info'
                            variant='outlined'
                            size="small"
                            startIcon={<Close />}
                            onClick={handleCloseDialog}
                        >
                            Batal
                        </ArgonButton>
                    </Grid>
                    <Grid item>
                        <LoadingButton
                            color='info'
                            variant='contained'
                            size="small"
                            startIcon={<Save />}
                            type='submit'
                            loading={saving}
                        >
                            Simpan
                        </LoadingButton>
                    </Grid>
                </Grid>
            </DialogActions>
        </Dialog>
    )
}

TambahSubKegiatan.prototype = {
    parentData: PropTypes.object.isRequired,
    open: PropTypes.bool.isRequired,
    handleCloseDialog: PropTypes.func.isRequired,
    decryptedUser: PropTypes.string.isRequired,
    tahunAnggaran: PropTypes.object.isRequired,
    updating: PropTypes.bool.isRequired,
    setUpdating: PropTypes.func.isRequired,
    addReq: PropTypes.func.isRequired,
}

export default TambahSubKegiatan